// extracted by mini-css-extract-plugin
export var drawerPaper = "_1w-0";
export var itemCard = "_1w-1";
export var itemImage = "_1w-2";